
import React from "react";
import { Route, Switch } from "react-router-dom";
import LandingV2 from './components/LandingV2';
import Docs from './components/Docs';
import TokenSale from './components/TokenSale';
import Test from './components/Test';

export default (props) => {
    return (
        <Switch>
            <Route path="/" exact component={LandingV2} />
            {/* /v2 kept as alias to the same component for any legacy bookmarks */}
            <Route path="/v2" exact component={LandingV2} />
            {/* /docs — public knowledge base; 5-min explainer + role walkthroughs + glossary */}
            <Route path="/docs" exact component={Docs} />
            <Route path="/tokensale" exact component={TokenSale} />
            <Route path="/test" exact component={Test} />
        </Switch>
    );
}
